export const FORM_NAME = 'CREATE_RULES_SIDEBAR_FORM';
export const STAGESET_RULES_FIELD_NAME = 'stagesetFieldRules';
